/**
 * `/$tenantSlug/settings/module-lists` — the company's choices about the
 * starting lists its switched-on modules bring (SS-B8-T1, ADR-0275 point 6).
 *
 * The page itself is `components/ModuleListsSettings.tsx`, imported on demand:
 * this file holds only the route and its permission gate, so a visitor who never
 * opens Settings → Module lists never downloads it. The gate is outside the
 * lazy boundary. Changes additionally need `shell.settings.edit`, checked inside
 * the page and by the API.
 */

import { RequirePermission } from "@ken/auth";
import { Skeleton } from "@ken/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy, type ReactElement } from "react";

const ModuleListsSettingsContent = lazy(async () => import("../components/ModuleListsSettings"));

export const Route = createFileRoute("/$tenantSlug/settings/module-lists")({
  component: ModuleListsSettingsRoute,
});

function ModuleListsSettingsRoute(): ReactElement {
  return (
    <RequirePermission slug="shell.settings.view">
      <Suspense fallback={<Skeleton className="h-40 w-full" />}>
        <ModuleListsSettingsContent />
      </Suspense>
    </RequirePermission>
  );
}
